import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { Getrequest, Putrequest } from '../../../../context/AxiosRequest';
import { ContextData } from '../../../../context/Context';
import { toast } from 'react-toastify';
import SoundAlert from '../../../../routes/SoundAlert';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ReturnApplication() {




  const [open, setOpen] = React.useState(false);
  const {UserTokens,accesstoken,GlobalLoader,setGlobalLoader} = React.useContext(ContextData)

      const handleSubmit = ()=>{

                   (async ()=>{


                      const response = await Getrequest(`auth/returned_application_process/${UserTokens}`,accesstoken)
                       
                          if(response.status){
                             setGlobalLoader(!GlobalLoader)
                              toast.success(response.textStatus)
                              SoundAlert("success")
                              setOpen(false)
                          }else{

                              setGlobalLoader(!GlobalLoader)
                              toast.error(response.textStatus)
                              SoundAlert("error")
                             
                          }

                   })()
      }

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

return (
    <React.Fragment>
        <Button sx={{background:"red"}} variant="contained" onClick={handleClickOpen}>
            Return Application
        </Button>
        <Dialog
            open={open}
            slots={{
                transition: Transition,
            }}
            keepMounted
            onClose={handleClose}
            aria-describedby="alert-dialog-slide-description"
        >
          
            <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                    <h1 className='text-2xl text-red-600 font-semibold'>Note</h1>
                </DialogContentText>
                <DialogContentText sx={{padding:"6px"}} id="alert-dialog-slide-description">
                    Are you sure you want to return your application to continue the loan process?
                </DialogContentText>
                <DialogContentText  sx={{padding:"6px"}} id="alert-dialog-slide-description">
                    Please ensure you have provided the correct required documents or information. Repetition of incorrect details may disqualify you from selection.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Not Finish</Button>
                <Button variant='contained' onClick={handleSubmit}>Yes sure</Button>
            </DialogActions>
        </Dialog>
    </React.Fragment>
);
}
